/** Stable client-side ids for draft list rows (menu groups/items,
 * timeline days/events) — persisted into the config payloads. */
export function makeId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `id-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}
